/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExtensionOrderImportItemDTOFromJSON, ExtensionOrderImportItemDTOToJSON, } from './ExtensionOrderImportItemDTO';
/**
 * Check if a given object implements the ImportOrdersFromExtensionRequest interface.
 */
export function instanceOfImportOrdersFromExtensionRequest(value) {
    if (!('orders' in value) || value['orders'] === undefined)
        return false;
    return true;
}
export function ImportOrdersFromExtensionRequestFromJSON(json) {
    return ImportOrdersFromExtensionRequestFromJSONTyped(json, false);
}
export function ImportOrdersFromExtensionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orders': (json['orders'].map(ExtensionOrderImportItemDTOFromJSON)),
    };
}
export function ImportOrdersFromExtensionRequestToJSON(json) {
    return ImportOrdersFromExtensionRequestToJSONTyped(json, false);
}
export function ImportOrdersFromExtensionRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orders': (value['orders'].map(ExtensionOrderImportItemDTOToJSON)),
    };
}
